import { graphql, useFragment } from 'react-relay';

import {
  BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$data,
  BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$key,
} from '../../../relay/__generated__/BrandMessageTaskConnectionDataTable_brandMessageTaskConnection.graphql';
import DataTable, { DataTableProps } from '../../core/DataTable';
import DateText from '../../core/DateText';
import Label from '../../core/Label';
import Text from '../../core/Text';
import UserAvatarText from '../../user/UserAvatarText';

const BrandMessageTaskConnectionDataTable_brandMessageTaskConnection = graphql`
  fragment BrandMessageTaskConnectionDataTable_brandMessageTaskConnection on BrandMessageTaskConnection {
    edges {
      node {
        id
        sequence
        created
        createdBy {
          ...UserAvatarText_user
        }
        title
        description
        template {
          templateCode
          templateName
        }
        startAt
        period
        isActive
      }
    }
  }
`;

type Props = {
  brandMessageTaskConnection: BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$key;
} & Omit<
  DataTableProps<BrandMessageTaskConnectionDataTable_brandMessageTaskConnection$data['edges'][number]['node']>,
  'rows' | 'columns'
>;

const BrandMessageTaskConnectionDataTable = ({ brandMessageTaskConnection, ...props }: Props) => {
  const { edges } = useFragment(
    BrandMessageTaskConnectionDataTable_brandMessageTaskConnection,
    brandMessageTaskConnection,
  );

  return (
    <DataTable
      rows={edges.map(({ node }) => node).filter((node) => !!node)}
      columns={[
        {
          field: 'isActive',
          title: '상태',
          renderValue: ({ isActive }) =>
            isActive ? <Label variant={'success'}>활성화</Label> : <Label variant={'secondary'}>비활성화</Label>,
          width: 20,
        },
        {
          field: 'sequence',
          title: 'ID',
          renderValue: ({ sequence }) => <Text fontSize={1}>{sequence}</Text>,
          width: 50,
        },

        {
          field: 'title',
          title: '제목',
          renderValue: ({ title }) => <Text fontSize={1}>{title}</Text>,
          width: 160,
        },
        {
          field: 'template.templateCode',
          title: '템플릿 코드',
          renderValue: ({ template }) => <Text fontSize={1}>{template?.templateCode}</Text>,
          width: 140,
        },
        {
          field: 'template.templateName',
          title: '템플릿 이름',
          renderValue: ({ template }) => <Text fontSize={1}>{template?.templateName}</Text>,
          width: 140,
        },

        {
          field: 'startAt',
          title: '시작일',
          renderValue: ({ startAt }) => <DateText fontSize={1}>{startAt}</DateText>,
          width: 140,
        },
        {
          field: 'period',
          title: '주기',
          renderValue: ({ period }) => <Text fontSize={1}>{period ? period + '일' : '-'}</Text>,
          width: 50,
        },
        {
          field: 'created',
          title: '제작일',
          renderValue: ({ created }) => <DateText fontSize={1}>{created}</DateText>,
          width: 120,
        },
        {
          field: 'createdBy',
          title: '제작자',
          renderValue: ({ createdBy }) => <UserAvatarText user={createdBy} />,
          width: 80,
        },
      ]}
      {...props}
    />
  );
};

export default BrandMessageTaskConnectionDataTable;
